import React from "react";
import { useDialog } from "contexts";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { StyledButton, StyledDialog } from "customStyled";
import { useTranslation } from "react-i18next";

const InfoDialog = () => {
  const { t } = useTranslation();
  const { info, hideInfo } = useDialog();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const handleClose = () => {
    if (!!info.close) {
      info.close();
    }
    hideInfo();
  };
  return (
    <React.Fragment>
      <StyledDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullScreen={fullScreen}
        open={!!info}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {info?.title || t("info")}
        </DialogTitle>
        <DialogContent sx={{ width: 400 }} dividers>
          <Typography sx={{ textAlign: "center" }} gutterBottom>
            {info?.message}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <StyledButton variant="contained" onClick={handleClose}>
            {t("ok")}
          </StyledButton>
        </DialogActions>
      </StyledDialog>
    </React.Fragment>
  );
};

export default InfoDialog;
